<div class="container mt-4 student-list-shell">
  <div class="student-list-toolbar">
    <div class="student-list-heading">
      <h4 class="student-list-title">
        <i class="fa" [ngClass]="iIsArchived ? 'fa-archive' : 'fa-users'" aria-hidden="true"></i>
        {{ iIsArchived ? 'Élèves archivés' : 'Élèves' }}
      </h4>
      <div class="student-list-counters">
        @if (iPageStudent) {
          <span class="student-list-count">
            {{ iPageStudent.totalElements }} élève{{ iPageStudent.totalElements > 1 ? 's' : '' }}{{ onlyToCreate ? ' à créer' : '' }}
          </span>
        }
        @if (toCreateCount > 0 || onlyToCreate) {
          <button type="button" class="student-to-create-chip"
            [class.active]="onlyToCreate" [attr.aria-pressed]="onlyToCreate" (click)="toggleToCreate()">
            @if (!onlyToCreate) {
              <span class="student-to-create-badge">{{ toCreateCount }}</span>
              <span>élève{{ toCreateCount > 1 ? 's' : '' }} à créer</span>
              <span class="student-to-create-action">Voir <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
            }
            @if (onlyToCreate) {
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              <span>Afficher tous les élèves</span>
            }
          </button>
        }
      </div>
    </div>

    <div class="student-list-actions">
      <div id="search" class="student-list-search">
        <i class="fa fa-search student-list-search-icon" aria-hidden="true"></i>
        <input type="search" id="inputStudent" #studentInput
          class="form-control"
          placeholder="Rechercher un élève"
          aria-label="Rechercher un élève"
          (input)="onSearchChange($event.target)">
      </div>
      @if (!iIsArchived && !readOnlyService.isReadOnly() && !iUseExternalDataFlow) {
        <a
          routerLink="/new-student" class="btn student-list-add">
          <i class="fa fa-plus" aria-hidden="true"></i><span>Nouvel élève</span>
        </a>
      }
    </div>
  </div>

  <div class="student-table-card">
    <table class="table student-table">
      <thead>
        <tr>
          <th scope="col">Élève</th>
          <th scope="col" class="student-col-formula">Formule</th>
          <th scope="col" class="student-col-status">Statut</th>
          <th scope="col" class="student-col-date">Inscription</th>
          <th scope="col" class="student-col-arrow"><span class="visually-hidden">Ouvrir</span></th>
        </tr>
      </thead>
      <tbody>
        @for (s of iStudents; track s) {
          <tr (click)="consultStudent(s.id)" (keydown.enter)="consultStudent(s.id)"
            tabindex="0" [ngClass]="{'new-student': s.status === 'TO_CREATE'}">
            <td class="student-cell-identity">
              <span class="student-avatar" [ngClass]="'avatar-' + avatarColor(s)">{{ initials(s) }}</span>
              <span class="student-identity">
                <span class="student-name">{{ s.lastname | uppercase }} {{ s.firstname }}</span>
                @if (s.phoneNumber || s.email) {
                  <span class="student-contact">{{ s.phoneNumber || s.email }}</span>
                }
              </span>
            </td>
            <td class="student-col-formula" data-label="Formule">
              @if (s.formula) {
                <span class="student-formula">{{ s.formula.name }}</span>
              }
            </td>
            <td class="student-col-status" data-label="Statut">
              <span class="student-status" [ngClass]="'status-' + (s.status || 'UNKNOWN')">{{ getStatusValue(s.status) }}</span>
            </td>
            <td class="student-col-date" data-label="Inscription">{{ s.registrationDate | date:'dd/MM/yyyy' }}</td>
            <td class="student-col-arrow"><i class="fa fa-chevron-right" aria-hidden="true"></i></td>
          </tr>
        }
      </tbody>
    </table>

    @if (iStudents && iStudents.length === 0) {
      <div class="student-empty">
        <i class="fa fa-user-o" aria-hidden="true"></i>
        <p>{{ inputSearchName ? 'Aucun élève ne correspond à « ' + inputSearchName + ' ».' : 'Aucun élève pour le moment.' }}</p>
      </div>
    }
  </div>

  @if (iPageStudent) {
    <app-pagination [iEmpty]="iPageStudent.empty" [iFirst]="iPageStudent.first"
      [iLast]="iPageStudent.last" [iNumber]="iPageStudent.number" [iTotalPages]="iPageStudent.totalPages"
      [iPageSize]="iPageStudent.size"
      (currentPageChanged)="onChangeStudentPage($event)">
    </app-pagination>
  }
</div>
